// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xAo_","rootNoMargin":"styles_rootNoMargin__1e5zf"};